import { render, staticRenderFns } from "./CandidateShow.vue?vue&type=template&id=40363562&scoped=true&"
import script from "./CandidateShow.vue?vue&type=script&lang=js&"
export * from "./CandidateShow.vue?vue&type=script&lang=js&"
import style0 from "./CandidateShow.vue?vue&type=style&index=0&id=40363562&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40363562",
  null
  
)

component.options.__file = "CandidateShow.vue"
export default component.exports